import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import PageTitle from '../../components/pagetitle/PageTitle'
import Error from '../../components/404/404'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo.svg'
const ErrorPage = () => {
    return (
        <Fragment>
            <SEO title="404" />
            <NavbarS2 hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <PageTitle pageTitle={'404'} pagesub={'404'} />
            <Error />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ErrorPage;



